import React from 'react';
import styled from 'styled-components';
import CalendarRow from './../CalendarRow/CalendarRow';
import CalendarHeader from './../CalendarHeader/CalendarHeader';
import theme from '../../assets/styles/theme';
import PropTypes from 'prop-types';

const Calendar = (props) => {
  const weeks = props.weeks.map((row, idx) => {
    return <CalendarRow key={'week' + idx} row={row} />;
  });

  return (
    <Container data-testid='calendar-data-test-id'>
      <CalendarHeader header={props.header} />
      {weeks}
    </Container>
  );
};

Calendar.propTypes = {
  header: PropTypes.shape({
    year: PropTypes.string,
    month: PropTypes.string,
  }).isRequired,
  weeks: PropTypes.array.isRequired,
};

const Container = styled.div`
  background-color: ${theme.oldColors.white[600]};
  min-width: 1150px;
`;

export default Calendar;
